import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  ListSubheader,
  Popover,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../Vendors/Vendors.css";
import "./IntService.css";
import DataTable from "../Tables/DataTable/DataTable";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import {
  ClearSelectionData,
  SelectionFilter,
} from "../../utilities/SelectionFilter";
import ApiServices from "../../services/ApiServices";
import { useLoading } from "../../hooks/useLoader";
import {
  MASTER_DATA,
  VENDOR_INTEGRATIONSERVICE,
  VENDOR_INTEGRATIONSERVICE_LIST,
  VENDOR_INTEGRATIONSERVICE_STATUS,
  VENDOR_INTEGRATIONSERVICEREQUEST_UPLOADFILE,
  VENDOR_INTEGRATIONSOLUTION,
} from "../../constants/api-constants";
import { toast } from "react-toastify";
import { MenuListItems } from "../../common/Sidebar/MenuListItems";
import { SystemModulesEnum } from "../../constants/SystemUsers";
import {
  childModulePermissions,
  PermissionEnum,
} from "../../constants/permissionService";
import { useVendorContext } from "../Vendors/Vendor.context";
import Confirmation from "../../common/Confirmation/Confirmation";
import {
  HTTPVERB,
  // INTEGRATION_TYPE,
  STATUS_ENUM,
  TABS,
} from "../../constants/common";
import { MandatoryField } from "../../common/MandatoryFieldsIcon/MandatoryField";
import { a11yProps } from "../../common/TabPanel/a11yProps";
import CheckboxList from "../../common/CheckboxList/CheckboxList";
import { useFormik } from "formik";
import FooterButtons from "../../common/FooterButtons/FooterButtons";
import { useAuth } from "../../hooks/useAuth";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import APISchemaTree from "./ApiSchemaTree";
import { VendorIntegrationServiceSchema } from "../../common/ValidationSchema/ValidationSchema";
import FileUploader from "../../common/FileUploader/FileUploader";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { getFileExtension } from "../../utilities/common";
import XFDLDropdown from "../../common/XFDLDropdown/XfdlDropdown";
import PropTypes from "prop-types";

const SOLUTION_TYPE = {
  THIRD_PARTY: 1,
  INCHANTED: 2,
};

const INTEGRATION_TYPE = {
  API_KEY: 3,
  BASIC: 1,
  JWT: 2,
};

const INCHANTED_ADDINS = [
  "IRMI Glossary of Terms",
  "Share Using Inchanted",
  "Reusable Link",
  "Apryse",
];

const BASIC_JWT_INFO_MESSAGE =
  "Additional configuration may be required at Enterprise or End User level.";

function flattenJson(obj, prefix = "") {
  const result = {};

  const processValue = (value, key) => {
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (Array.isArray(value)) {
      processArray(value, newKey);
    } else if (isObjectWithSingleValue(value)) {
      result[newKey] = value.value;
    } else if (isRegularObject(value)) {
      Object.assign(result, flattenJson(value, newKey));
    } else {
      result[newKey] = value;
    }
  };

  const processArray = (array, newKey) => {
    array.forEach((item, index) => {
      Object.assign(result, flattenJson(item, `${newKey}[${index}]`));
    });
  };

  const isObjectWithSingleValue = (value) =>
    typeof value === "object" &&
    value !== null &&
    "value" in value &&
    Object.keys(value).length === 1;

  const isRegularObject = (value) =>
    typeof value === "object" &&
    value !== null &&
    !isObjectWithSingleValue(value);

  Object.keys(obj).forEach((key) => {
    if (obj.hasOwnProperty(key)) {
      processValue(obj[key], key);
    }
  });

  return result;
}

/*istanbul ignore next */
const IntServiceList = (props) => {
  const auth = useAuth();
  const { showLoader } = useLoading();
  const { id } = useParams();
  const permissionId = auth.getPermissionId();
  const vendorContext = useVendorContext();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [isEditMode, setIsEditMode] = useState(vendorContext.isEditMode);
  const [vendorTable, setVendorTableData] = useState([]);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedSolution, setSelectedSolution] = useState(null);
  const [openServiceModal, setopenServiceModal] = React.useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [expanded, setExpanded] = React.useState("panel1");
  const [expanded2, setExpanded2] = React.useState("panel2");
  const [selectedTab, setSelectedTab] = useState(TABS.SERVICE_BASIC);
  const [solutionDetails, setSolutionDetails] = useState(null);
  const [solutionType, setSolutionType] = useState(0);
  const [solutionIntegrationType, setSolutionIntegrationType] = useState(0);
  const [inchantedAddinType, setInchantedAddinType] = useState(0);
  const [solutionApiKeyList, setSolutionApiKeyList] = useState([]);
  const [solutionTypeOptions, setSolutionTypeOptions] = useState([
    { key: SOLUTION_TYPE.THIRD_PARTY, value: "Third Party" },
    { key: SOLUTION_TYPE.INCHANTED, value: "Inchanted" },
  ]);
  const [integrationTypeOptions, setIntegrationTypeOptions] = useState([
    { key: INTEGRATION_TYPE.API_KEY, value: "API Key" },
    { key: INTEGRATION_TYPE.BASIC, value: "Basic" },
    { key: INTEGRATION_TYPE.JWT, value: "JWT" },
  ]);
  const [addToOptions, setAddToOptions] = useState([
    { key: 1, value: "Header" },
    { key: 2, value: "Query Parameter" },
  ]);
  const [inchantedAddinOptions, setInchantedAddinOptions] = useState(
    INCHANTED_ADDINS.map((value, index) => ({
      key: index + 1,
      value,
    })),
  );
  const [integrationServiceId, setIntegrationServiceId] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [file, setFile] = useState(null);
  const [fileResponse, setFileResponse] = useState(null);
  const [sourceDropdown, setSourceDropdown] = useState([]);
  const [clientFolderDropdown, setClientFolderDropdown] = useState([]);
  const [schemaError, setSchemaError] = useState(false);
  const [schemaErrorResp, setSchemaErrorResp] = useState(false);
  const [eLabelDropdown, setElabelDropdown] = useState([]);
  const open2 = Boolean(anchorEl);
  const handleConfirmationOpen = (actionName, cnfMessage) => {
    setConfirmationMessage(cnfMessage);
    setConfirmation(true);
  };
  const handleConfirmationClose = () => {
    setConfirmationMessage("");
    setConfirmation(false);
  };

  const vendorServiceInit = {
    serviceName: "",
    serviceAPIURL: "",
    integrationMethodText: "",
    integrationTypeText: "",
    integrationType: 0,
    integrationMethod: 0,
    integrationServiceId: integrationServiceId,
    vendorId: Number(props.vendorId),
    integrationSolutionId: props.integrationSolutionId,
    status: 1,
    integrationTypeBasic: null,
    integrationTypeJWT: null,
    integrationTypeAPIKeyList: [],
    integrationServiceRequest: null,
    integrationServiceResponse: null,
  };

  const formik = useFormik({
    initialValues: vendorServiceInit,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    enableReinitialize: true,
    validationSchema: VendorIntegrationServiceSchema,
  });

  const [query, setQuery] = useState({
    searchText: "",
    SortType: "desc",
    IgnorePaging: false,
    SortColumn: "userId",
    PageNumber: 1,
    PageSize: 10,
    Filter: {
      Status: selectedStatus,
    },
  });

  const sstyle = {
    width: "100%",
    minHeight: "100%",
    bgcolor: "#f4f8fc",
    p: 0,
  };

  useEffect(() => {
    if (id && vendorIntSolutionPermission?.includes(PermissionEnum.LIST)) {
      vendorServiceList();
    }
  }, [query]);

  useEffect(() => {
    setSelectionColumns();
    loadDropdownOptions();
  }, []);

  useEffect(() => {
    if (integrationServiceId > 0 && openServiceModal) {
      vendorServiceDetails();
    }
  }, [integrationServiceId, openServiceModal]);

  useEffect(() => {
    // Reset everything when modal closes
    if (!openServiceModal) {
      formik.resetForm();
      formik.setValues(vendorServiceInit);
      setIntegrationServiceId(0);
      setFile(null);
      setFileResponse(null);
      setSchemaError(false);
      setSchemaErrorResp(false);
      setSelectedTab(TABS.SERVICE_BASIC);
    }
  }, [openServiceModal]);

  useEffect(() => {
    if (props.integrationSolutionId) {
      vendorSolutionDetails();
    }
  }, [props.integrationSolutionId]);

  useEffect(() => {
    if (props.shouldOpenServiceModal) {
      setopenServiceModal(true);
      setIsEditMode(true);
      setSelectedTab(TABS.SERVICE_BASIC);
      props.setShouldOpenServiceModal(false);
      setExpanded(false);
    }
  }, [props.shouldOpenServiceModal]);

  let vendorContactModuleId = MenuListItems.find(
    (item) => item.name === SystemModulesEnum.VENDORS,
  )?.moduleId;
  const vendorIntSolutionPermission = childModulePermissions(
    vendorContactModuleId,
    SystemModulesEnum.VENDOR_INTEGRATION_SOLUTION,
  );

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleChange2 = (panel) => (event, newExpanded) => {
    setExpanded2(newExpanded ? panel : false);
  };

  const onSearchHandler = (event) => {
    ClearSelectionData();
    setTimeout(() => {
      setQuery((prevState) => {
        return {
          ...prevState,
          PageNumber: 1,
          searchText: event.target.value,
        };
      });
    }, 1000);
  };
  const fieldMapping = {
    integrationTypeText: "integrationType",
    integrationMethodText: "integrationMethod",
  };

  const sortHandler = (sortOrder, sortBy) => {
    const mappedSortBy = fieldMapping[sortBy] || sortBy;
    setQuery((prevState) => {
      if (prevState.SortColumn === mappedSortBy) {
        return {
          ...prevState,
          SortType: sortOrder === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          ...prevState,
          SortColumn: mappedSortBy,
          SortType: "asc",
        };
      }
    });
  };

  const handleChangePageNumber = (event, newPage) => {
    setQuery((prevState) => {
      return { ...prevState, PageNumber: newPage };
    });
  };
  /*istanbul ignore next */
  const pageSizeChangeHandler = (PageSize) => {
    setQuery((prevState) => {
      return { ...prevState, PageSize: PageSize, PageNumber: 1 };
    });
  };
  const handleVendorSolutionClose = () => {
    props?.onCancel();
    setopenServiceModal(false);
    setSelectedTab(TABS.SERVICE_BASIC);
    formik.setValues(vendorServiceInit);
    vendorServiceList();
  };
  const applyFilterHandler = (Filter) => {
    ClearSelectionData();
    setQuery((prevState) => {
      return {
        ...prevState,
        PageNumber: 1,
        Filter: {
          Status: selectedStatus,
        },
      };
    });
  };

  const loadDropdownOptions = async () => {
    try {
      const url = `${MASTER_DATA}?include=enumMasterData`;
      const response = await ApiServices.httpGet(url);
      const enumMasterData = response?.result?.enumMasterData || {};
      localStorage.setItem("enumMasterData", JSON.stringify(enumMasterData));
      if (
        Array.isArray(enumMasterData.integrationSolutionTypes) &&
        enumMasterData.integrationSolutionTypes.length > 0
      ) {
        setSolutionTypeOptions(enumMasterData.integrationSolutionTypes);
      }
      if (
        Array.isArray(enumMasterData.integrationTypes) &&
        enumMasterData.integrationTypes.length > 0
      ) {
        setIntegrationTypeOptions(enumMasterData.integrationTypes);
      }
      if (
        Array.isArray(enumMasterData.addRequestTos) &&
        enumMasterData.addRequestTos.length > 0
      ) {
        setAddToOptions(enumMasterData.addRequestTos);
      }
      if (
        Array.isArray(enumMasterData.inchantedAddinTypes) &&
        enumMasterData.inchantedAddinTypes.length > 0
      ) {
        setInchantedAddinOptions(enumMasterData.inchantedAddinTypes);
      }
      setSourceDropdown(enumMasterData.sources || []);
      setElabelDropdown(enumMasterData.xfdLeLabels || []);
      setClientFolderDropdown(enumMasterData.clientDetails || []);
    } catch (error) {
      console.error("Failed to load dropdown options", error);
    }
  };

  const handleSchemaRequestValue = (updatedList) => {
    formik.setValues({
      ...formik.values,
      integrationServiceRequest: {
        ...formik.values.integrationServiceRequest,
        requestParameterList: updatedList,
      },
    });
  };

  const handleSchemaResponseValue = (updatedList) => {
    formik.setValues({
      ...formik.values,
      integrationServiceResponse: {
        ...formik.values.integrationServiceResponse,
        responseParameterList: updatedList,
      },
    });
  };

  const handleAddRow = () => {
    const currentList =
      formik.values.integrationServiceRequest?.requestParameterList || [];
    formik.setValues({
      ...formik.values,
      integrationServiceRequest: {
        ...formik.values.integrationServiceRequest,
        requestParameterList: [
          ...currentList,
          {
            uniqueId: Math.floor(Math.random() * 1000),
            parameterName: null,
            source: null,
            eLabel: 0,
            clientDetails: 0,
            defaultValue: "",
          },
        ],
      },
    });
  };

  const handleRemoveRow = (uniqueId) => {
    formik.setValues({
      ...formik.values,
      integrationServiceRequest: {
        ...(formik.values?.integrationServiceRequest?.httpVerb === 0),
        ...formik.values.integrationServiceRequest,
        requestParameterList:
          formik.values.integrationServiceRequest?.requestParameterList.filter(
            (row) => row.uniqueId !== uniqueId,
          ),
      },
    });
  };

  const handleInputChange = (id, field, value) => {
    formik.setValues({
      ...formik.values,
      integrationServiceRequest: {
        ...formik.values.integrationServiceRequest,
        requestParameterList:
          formik.values.integrationServiceRequest?.requestParameterList.map(
            (row) => (row.uniqueId === id ? { ...row, [field]: value } : row),
          ),
      },
    });
  };

  const onCheckboxChangeHandler = (e, value) => {
    const { checked } = e.target;
    if (value === "all") {
      setVendorTableData((items) => {
        SelectionFilter(items, "multiple", checked);
        return items.map((data) => {
          return {
            ...data,
            isChecked: checked,
          };
        });
      });
    } else {
      setVendorTableData((items) => {
        return items.map((user) => {
          let userRecord = { ...user };
          if (user.integrationServiceId === value) {
            SelectionFilter(user, "single", checked, "integrationServiceId");
            userRecord.isChecked = checked;
          }
          return userRecord;
        });
      });
    }
  };

  const onCancelHandler = () => {
    setIsEditMode(false);
    handleVendorSolutionClose();
  };
  const onEditHandler = () => {
    setIsEditMode(true);
  };

  const onEdit = (record) => {
    setIntegrationServiceId(record.integrationServiceId);
    setIsEditMode(true);
    setopenServiceModal(true);
  };
  const onView = (record) => {
    setIntegrationServiceId(record.integrationServiceId);
    setIsEditMode(false);
    setopenServiceModal(true);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onFilterStatusChangeHandler = (values) => {
    setSelectedStatus(values);
  };
  const clearFilterHandler = () => {
    setSelectedStatus([]);
  };

  const setSelectionColumns = () => {
    let selectedCols = localStorage.getItem("selectedColumns")
      ? JSON.parse(localStorage.getItem("selectedColumns"))
      : null;
    let adminCols = selectedCols?.listOfServiceDataColunms
      ? selectedCols?.listOfServiceDataColunms
      : null;
    if (adminCols) {
      setSelectedColumns(adminCols);
    }
  };

  const onToggleHandler = async (
    column,
    userId,
    contentSubscriberStatus,
    e,
    selectedSolution,
  ) => {
    setSelectedSolution(selectedSolution);
    if (selectedSolution.status === 1) {
      handleConfirmationOpen(
        "Inactivate",
        "Are you sure you want to mark the Integration Service as Inactive?",
      );
    } else {
      changeContentStatus(selectedSolution, STATUS_ENUM.ACTIVE);
    }
  };
  const changeContentStatus = async (vendorObj, status) => {
    try {
      const response = await ApiServices.httpPut(
        VENDOR_INTEGRATIONSERVICE_STATUS,
        {
          integrationServiceId: vendorObj.integrationServiceId,
          status: Number(status),
        },
      );

      if (response.responseStatus.isSuccess) {
        toast.success(response.responseStatus.description);
        handleConfirmationClose();
        vendorServiceList();
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (event) {
      toast.error("Internal server error");
    }
  };

  const vendorServiceDetails = async () => {
    showLoader(true);
    const data = await ApiServices.httpGet(
      `${VENDOR_INTEGRATIONSERVICE}/${integrationServiceId}`,
    );
    showLoader(false);
    formik.setValues({
      ...data.result,
      integrationServiceRequest: data.result.integrationServiceRequest
        ? {
            ...data.result.integrationServiceRequest,
            requestParameterList:
              data.result.integrationServiceRequest?.requestParameterList?.map(
                (row) => ({
                  ...row,
                  uniqueId: Math.floor(Math.random() * 1000),
                }),
              ),
          }
        : null,
      integrationServiceResponse: data.result.integrationServiceResponse
        ? {
            ...data.result.integrationServiceResponse,
            responseParameterList:
              data.result.integrationServiceResponse?.responseParameterList?.map(
                (row) => ({
                  ...row,
                  uniqueId: Math.floor(Math.random() * 1000),
                }),
              ),
          }
        : null,
    });
    let resultObject = {
      name: data.result.integrationSolutionName,
      description: data.result.integrationSolutionDescription,
    };
    setSolutionDetails(resultObject);
  };

  const vendorSolutionDetails = async () => {
    showLoader(true);
    const data = await ApiServices.httpGet(
      `${VENDOR_INTEGRATIONSOLUTION}/${props.integrationSolutionId}`,
    );
    showLoader(false);
    const result = data?.result || {};
    const resolvedSolutionType = Number.isFinite(Number(result.solutionType))
      ? Number(result.solutionType)
      : solutionTypeOptions.find(
          (option) =>
            option.value?.toLowerCase() ===
            String(result.solutionTypeText || "").toLowerCase(),
        )?.key || 0;
    const resolvedIntegrationType = Number.isFinite(
      Number(result.integrationType),
    )
      ? Number(result.integrationType)
      : integrationTypeOptions.find(
          (option) =>
            option.value?.toLowerCase() ===
            String(result.integrationTypeText || "").toLowerCase(),
        )?.key || 0;
    const resolvedInchantedAddinType = Number.isFinite(
      Number(result.inchantedAddinType),
    )
      ? Number(result.inchantedAddinType)
      : inchantedAddinOptions.find(
          (option) =>
            option.value?.toLowerCase() ===
            String(result.inchantedAddinTypeText || "").toLowerCase(),
        )?.key || 0;
    const apiKeys = (result.integrationTypeAPIKeyList || []).map((item) => {
      let resolvedHasKeyValue = false;

      if (typeof item.hasKeyValue === "boolean") {
        resolvedHasKeyValue = item.hasKeyValue;
      } else if (typeof item.isKeyValue === "boolean") {
        resolvedHasKeyValue = item.isKeyValue;
      } else if (typeof item.hasValue === "boolean") {
        resolvedHasKeyValue = item.hasValue;
      }

      return {
        ...item,
        hasKeyValue: resolvedHasKeyValue,
      };
    });

    setSolutionDetails({
      name: result.name,
      description: result.description,
    });
    setSolutionType(resolvedSolutionType);
    setSolutionIntegrationType(resolvedIntegrationType);
    setInchantedAddinType(resolvedInchantedAddinType);
    setSolutionApiKeyList(apiKeys);
  };

  const vendorServiceList = async () => {
    try {
      showLoader(true);
      const contactQuery = {
        ...query,
        Filter: {
          ...query.Filter,
          vendorId: props.vendorId,
          integrationSolutionId: props.integrationSolutionId,
        },
      };
      const vendorData = await ApiServices.httpGet(
        `${VENDOR_INTEGRATIONSERVICE_LIST}/${JSON.stringify(contactQuery)}`,
      );
      showLoader(false);
      if (vendorData.responseStatus.isSuccess) {
        const integrationMethodMap = {
          1: "AL3",
          2: "JSON",
          3: "XML",
        };
        const records = (vendorData?.result?.records || []).map((row) => ({
          ...row,
          integrationMethodText:
            row.integrationMethodText ||
            integrationMethodMap[row.integrationMethod] ||
            "-",
          integrationTypeText:
            row.integrationTypeText ||
            integrationTypeOptions.find(
              (opt) => opt.key === row.integrationType,
            )?.value ||
            "-",
        }));
        setVendorTableData(records);
        setTotalPages(vendorData?.result?.totalPages);
        setPageSize(vendorData?.result?.pageSize);
      } else {
        toast.error(vendorData.responseStatus.error);
      }
    } catch (e) {
      showLoader(false);
      toast.error();
    }
  };

  const addVendorSolutionServiceDetails = async (isNext) => {
    try {
      const payload = {
        ...formik.values,
      };
      showLoader(true);
      const response = await ApiServices.httpPost(
        VENDOR_INTEGRATIONSERVICE,
        payload,
      );
      if (response.responseStatus.isSuccess) {
        formik.setValues(response.result);
        if (isNext) {
          if (selectedTab === TABS.SERVICE_BASIC) {
            setSelectedTab(TABS.SERVICE_REQUEST);
          } else if (selectedTab === TABS.SERVICE_REQUEST) {
            setSelectedTab(TABS.SERVICE_RESPONSE);
          } else if (selectedTab === TABS.SERVICE_RESPONSE) {
            handleVendorSolutionClose();
          }
        } else {
          handleVendorSolutionClose();
        }
        toast.success(response.responseStatus.description);
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (e) {
      toast.error("Internal server error");
    } finally {
      showLoader(false);
    }
  };

  const updateVendorSolutionServiceDetails = async (isNext) => {
    try {
      const payload = {
        ...formik.values,
      };
      showLoader(true);
      const response = await ApiServices.httpPut(
        VENDOR_INTEGRATIONSERVICE,
        payload,
      );
      if (response.responseStatus.isSuccess) {
        formik.setValues(response.result);
        if (isNext) {
          if (selectedTab === TABS.SERVICE_BASIC) {
            setSelectedTab(TABS.SERVICE_REQUEST);
          } else if (selectedTab === TABS.SERVICE_REQUEST) {
            setSelectedTab(TABS.SERVICE_RESPONSE);
          } else if (selectedTab === TABS.SERVICE_RESPONSE) {
            setTimeout(() => {
              setopenServiceModal(true);
              formik.setValues(vendorServiceInit);
              setIntegrationServiceId(0);
              setSelectedTab(TABS.SERVICE_BASIC);
            }, 300);
          }
        } else {
          handleVendorSolutionClose();
        }
        toast.success(response.responseStatus.description);
      } else {
        toast.error(response.responseStatus.error);
      }
    } catch (e) {
      toast.error("Internal server error");
    } finally {
      showLoader(false);
    }
  };

  const readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = () => {
        reject(new Error("Failed to read file content"));
      };
      reader.readAsText(file);
    });
  };
  const readFileContentResponse = (fileResponse) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => resolve(event.target.result);
      reader.onerror = () => {
        reject(new Error("Failed to read file response"));
      };
      reader.readAsText(fileResponse);
    });
  };

  const parseAttributes = (xml) => {
    if (!xml.attributes || xml.attributes.length === 0) return null;
    const attrs = {};
    for (let j = 0; j < xml.attributes.length; j++) {
      const a = xml.attributes.item(j);
      attrs[a.nodeName] = a.nodeValue;
    }
    return attrs;
  };

  const getTextNodeValue = (xml) => {
    if (xml.nodeType === 3) {
      const v = xml.nodeValue.trim();
      return v || null;
    }
    return null;
  };

  const processChildNodes = (xml) => {
    const obj = {};
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      const nodeName = item.nodeName;

      if (nodeName === "#text") {
        const text = item.nodeValue.trim();
        if (text) return text; // ORIGINAL BEHAVIOR: bail out with text
        continue;
      }

      const childObj = xmlToJson(item);

      if (obj[nodeName] === undefined) {
        obj[nodeName] = childObj;
      } else {
        if (!Array.isArray(obj[nodeName])) {
          obj[nodeName] = [obj[nodeName]];
        }
        obj[nodeName].push(childObj);
      }
    }
    return obj;
  };

  const xmlToJson = (xml) => {
    const textValue = getTextNodeValue(xml);
    if (textValue) return textValue;
    const obj = {};
    const attrs = parseAttributes(xml);
    if (attrs) obj["@attributes"] = attrs;
    if (xml.hasChildNodes()) {
      const children = processChildNodes(xml);
      if (typeof children === "string") return children;
      Object.assign(obj, children);
    }
    return obj;
  };

  const parseXML = (xmlString) => {
    const INVALID_XML_ERROR =
      "Invalid XML format. Please upload a valid schema file.";
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "application/xml");
      if (xmlDoc.getElementsByTagName("parsererror").length > 0) {
        throw new Error(INVALID_XML_ERROR);
      }
      const root = xmlDoc.documentElement;
      if (!root || root.nodeName === "parsererror") {
        throw new Error(INVALID_XML_ERROR);
      }
      let hasValidChild = false;
      for (const node of root.childNodes) {
        if (node.nodeType === 1 && node.textContent?.trim() !== "") {
          hasValidChild = true;
          break;
        }
      }
      if (!hasValidChild) {
        throw new Error(INVALID_XML_ERROR);
      }
      return xmlToJson(root);
    } catch {
      throw new Error(INVALID_XML_ERROR);
    }
  };

  const handlePrepareSchema = async () => {
    if (!file) {
      toast.error("Please Upload a File First!");
      setSchemaError(true);
      return;
    }
    try {
      const fileContent = await readFileContent(file);
      let parsedData;
      const ext = file.name.split(".").pop().toLowerCase();
      if (ext === "json") {
        parsedData = JSON.parse(fileContent);
      } else if (ext === "xml") {
        parsedData = parseXML(fileContent);
      } else {
        toast.error("Unsupported file type. Only JSON and XML are allowed.");
        setSchemaError(true);
        return;
      }
      let response = flattenJson(parsedData);
      let formatedResponse = createKeyValueList(response);
      formik.setValues({
        ...formik.values,
        integrationServiceRequest: {
          ...formik.values.integrationServiceRequest,
          requestParameterList: formatedResponse,
        },
      });
      setSchemaError(false);
      toast.success("Schema Prepared Successfully!");
    } catch (err) {
      setSchemaError(true);
      toast.error(
        err.message ||
          "Failed to prepare schema. Please check the file content.",
      );
      console.error(err);
    }
  };

  const handlePrepareSchemaResponse = async () => {
    if (!fileResponse) {
      toast.error("Please Upload a File First!");
      setSchemaErrorResp(true);
      return;
    }
    try {
      const fileContent = await readFileContentResponse(fileResponse);
      let parserespdData;
      const ext = fileResponse.name.split(".").pop().toLowerCase();

      if (ext === "json") {
        try {
          parserespdData = JSON.parse(fileContent);
        } catch (jsonErr) {
          setSchemaErrorResp(true);
          throw new Error(
            "Invalid JSON format. Please upload a valid schema file.",
          );
        }
      } else if (ext === "xml") {
        parserespdData = parseXML(fileContent);
      } else {
        toast.error("Unsupported file type. Only JSON and XML are allowed.");
        setSchemaErrorResp(true);
        return;
      }
      let response = flattenJson(parserespdData);
      let formatedResponse = createKeyValueList(response);
      formik.setValues({
        ...formik.values,
        integrationServiceResponse: {
          ...formik.values.integrationServiceResponse,
          responseParameterList: formatedResponse,
        },
      });

      setSchemaErrorResp(false);
      toast.success("Schema Prepared Successfully!");
    } catch (err) {
      setSchemaErrorResp(true);
      toast.error(
        err.message ||
          "Failed to prepare schema. Please check the file content.",
      );
      console.error(err);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
    const ext = getFileExtension(selectedFile.name).toLowerCase();
    if (!["xml", "json"].includes(ext)) {
      e.target.value = null;
      toast.error("Please select a valid XML or JSON file");
      setFile("");
      setSchemaError(false);
      return;
    }
    setFile(selectedFile);
    const formData = new FormData();
    formData.append("File", selectedFile);
    formData.append("FileType", "Request");
    showLoader(true);
    try {
      const response = await ApiServices.httpPutFile(
        VENDOR_INTEGRATIONSERVICEREQUEST_UPLOADFILE,
        formData,
      );
      showLoader(false);
      if (response.responseStatus?.isSuccess) {
        formik.setValues({
          ...formik.values,
          integrationServiceRequest: {
            ...formik.values.integrationServiceRequest,
            requestGcpPath: response.result?.gcpFilePath,
          },
        });
      } else {
        toast.error(response.responseStatus?.error);
      }
    } catch (err) {
      showLoader(false);
      console.error("File upload failed:", err);
    }
  };
  const handleFileChangeResponse = async (e) => {
    const selectedFilesresp = e.target.files[0];
    if (!selectedFilesresp) return;
    const ext = getFileExtension(selectedFilesresp.name).toLowerCase();
    if (!["xml", "json"].includes(ext)) {
      e.target.value = null;
      toast.error("Please select a valid XML or JSON file");
      setFileResponse("");
      setSchemaErrorResp(false);

      return;
    }
    setFileResponse(selectedFilesresp);
    const formData = new FormData();
    formData.append("File", selectedFilesresp);
    formData.append("FileType", "Response");
    showLoader(true);
    try {
      const response = await ApiServices.httpPutFile(
        VENDOR_INTEGRATIONSERVICEREQUEST_UPLOADFILE,
        formData,
      );
      showLoader(false);
      if (response.responseStatus?.isSuccess) {
        formik.setValues({
          ...formik.values,
          integrationServiceResponse: {
            ...formik.values.integrationServiceResponse,
            responseGcpPath: response.result?.gcpFilePath,
          },
        });
      } else {
        toast.error(response.responseStatus?.error);
      }
    } catch (err) {
      showLoader(false);
      console.error("File upload failed:", err);
    }
  };

  const onDeleteFileHandler = () => {
    formik.setValues({
      ...formik.values,
      integrationServiceRequest: {
        ...formik.values.integrationServiceRequest,
        requestGcpPath: "",
        requestParameterList: [],
      },
    });
    setFile("");
  };

  const onDeleteFileHandlerResponse = () => {
    formik.setValues({
      ...formik.values,
      integrationServiceResponse: {
        ...formik.values.integrationServiceResponse,
        responseGcpPath: "",
        responseParameterList: [],
      },
    });
    setFileResponse("");
  };

  return (
    <>
      {!openServiceModal && (
      <Grid item xs={12}>
        <Box mb={2} mt={-1} className="top-right-actions">
          <div className="add-welcome-widgets">
            <div>
              <Popover
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                id={"simple-popover"}
                open={open2}
                anchorEl={anchorEl}
                onClose={handleClose}
              >
                <div className="expanded-filter">
                  <div className="filter-options">
                    <List
                      sx={{
                        width: "100%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                      subheader={
                        <ListSubheader
                          component="div"
                          id="nested-list-subheader"
                        >
                          Filters will be applied to your grid
                        </ListSubheader>
                      }
                    >
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography sx={{ width: "33%", flexShrink: 0 }}>
                            Status
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <CheckboxList
                            id="status"
                            options={[
                              { value: 1, label: "Active" },
                              { value: 0, label: "Inactive" },
                            ]}
                            onChange={onFilterStatusChangeHandler}
                            selectedValues={selectedStatus}
                          />
                        </AccordionDetails>
                      </Accordion>
                    </List>
                  </div>
                  <div className="modal-footer">
                    <Button
                      variant="outlined"
                      className="action-button mr-4"
                      onClick={clearFilterHandler}
                    >
                      Clear
                    </Button>
                    <Button
                      variant="contained"
                      className="action-button"
                      onClick={() => {
                        applyFilterHandler();
                        handleClose();
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              </Popover>
            </div>
            {props.integrationSolutionId > 0 &&
              vendorIntSolutionPermission?.includes(PermissionEnum.CREATE) && (
                <Tooltip placement="bottom" title="Add New Service">
                  <AddOutlinedIcon
                    name="add-icon"
                    onClick={() => {
                      formik.setValues(vendorServiceInit);
                      setIntegrationServiceId(0);
                      setopenServiceModal(true);
                      setIsEditMode(true);
                      setSelectedTab(TABS.SERVICE_BASIC);
                    }}
                  />
                </Tooltip>
              )}
            <Tooltip placement="bottom" title="Filter">
              <FilterAltOutlinedIcon
                title="filter-icon"
                onClick={handleClick}
              />
            </Tooltip>
          </div>
        </Box>
      </Grid>
      )}
      <Grid item xs={12} sx={{ display: openServiceModal ? "block" : "contents" }}>
        <Box>
          {openServiceModal && (
            <Box sx={sstyle} className="custom-modal">
              <form>
                <div
                  className="modal-body"
                  style={{
                    maxHeight: "100vh",
                    overflowY: "auto",
                    padding: "0 16px",
                    background: "#fff",
                  }}
                >
                  {!props.hideSolutionBasicDetails && (
                    <Accordion
                      className="accordion-ent"
                      expanded={expanded === "panel1"}
                      onChange={handleChange("panel1")}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography sx={{ fontWeight: 700 }}>
                          Basic Details
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid
                          container
                          padding={2}
                          className="blue-field-section"
                        >
                          <Grid
                            container
                            padding={0}
                            sx={{ background: "white" }}
                          >
                            <Grid item xs={12} p={2}>
                              <label
                                htmlFor="brandName"
                                style={{
                                  display: "block",
                                  marginBottom: "4px",
                                }}
                              >
                                Solution Name
                                <MandatoryField />
                              </label>
                              <input
                                id="name"
                                name="name"
                                className="form-label form-control"
                                type="text"
                                placeholder="Enter Solution Name"
                                style={{ width: "100%" }}
                                value={solutionDetails?.name}
                                onChange={(e) => {
                                  if (
                                    !formik.values?.name &&
                                    e.target.value === " "
                                  )
                                    return;
                                  formik.handleChange(e);
                                }}
                                disabled={
                                  !isEditMode ||
                                  props.selectedSubTab === TABS.VENDOR_SERVICES
                                }
                              />
                            </Grid>
                            <Grid item xs={12} p={2}>
                              <label
                                htmlFor="firstName"
                                style={{
                                  display: "block",
                                  marginBottom: "4px",
                                }}
                              >
                                Description
                                <MandatoryField />
                              </label>
                              <textarea
                                id="description"
                                name="description"
                                className="form-label form-control bs-cus scrollable-input-content"
                                type="text"
                                placeholder="Add Description"
                                value={solutionDetails?.description}
                                onChange={(e) => {
                                  if (
                                    !formik.values?.description &&
                                    e.target.value === " "
                                  )
                                    return;
                                  formik.setFieldValue("dirty", true);
                                  formik.handleChange(e);
                                }}
                                disabled={
                                  !isEditMode ||
                                  props.selectedSubTab === TABS.VENDOR_SERVICES
                                }
                                style={{
                                  ...(!isEditMode ||
                                  props.selectedSubTab === TABS.VENDOR_SERVICES
                                    ? {
                                        borderColor: "transparent",
                                        border: "none",
                                      }
                                    : {}),
                                }}
                              />
                            </Grid>
                            <Grid item xs={6} p={2}>
                              <label
                                htmlFor="solutionType"
                                style={{
                                  display: "block",
                                  marginBottom: "4px",
                                }}
                              >
                                Solution Type
                                <MandatoryField />
                              </label>
                              <select
                                id="solutionType"
                                name="solutionType"
                                className="form-label form-control"
                                style={{ width: "100%" }}
                                disabled={
                                  !isEditMode ||
                                  props.selectedSubTab === TABS.VENDOR_SERVICES
                                }
                                value={solutionType}
                                onChange={() => {}}
                              >
                                <option disabled value={0}>
                                  Select Solution Type
                                </option>
                                {solutionTypeOptions.map((option) => (
                                  <option key={option.key} value={option.key}>
                                    {option.value}
                                  </option>
                                ))}
                              </select>
                            </Grid>
                            {solutionType === SOLUTION_TYPE.THIRD_PARTY && (
                              <Grid item xs={6} p={2}>
                                <label
                                  htmlFor="integrationType"
                                  style={{
                                    display: "block",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Integration Type
                                  <MandatoryField />
                                </label>
                                <select
                                  id="integrationType"
                                  name="integrationType"
                                  className="form-label form-control"
                                  style={{ width: "100%" }}
                                  disabled={
                                    !isEditMode ||
                                    props.selectedSubTab ===
                                      TABS.VENDOR_SERVICES
                                  }
                                  value={solutionIntegrationType}
                                  onChange={() => {}}
                                >
                                  <option disabled value={0}>
                                    Select Integration Type
                                  </option>
                                  {integrationTypeOptions.map((option) => (
                                    <option key={option.key} value={option.key}>
                                      {option.value}
                                    </option>
                                  ))}
                                </select>
                              </Grid>
                            )}
                            {solutionType === SOLUTION_TYPE.THIRD_PARTY &&
                              (solutionIntegrationType ===
                                INTEGRATION_TYPE.BASIC ||
                                solutionIntegrationType ===
                                  INTEGRATION_TYPE.JWT) && (
                                <Grid item xs={12} p={2}>
                                  <Typography
                                    sx={{
                                      color: "#666",
                                      fontStyle: "italic",
                                      fontSize: "0.9rem",
                                    }}
                                  >
                                    {BASIC_JWT_INFO_MESSAGE}
                                  </Typography>
                                </Grid>
                              )}
                            {solutionType === SOLUTION_TYPE.THIRD_PARTY &&
                              solutionIntegrationType ===
                                INTEGRATION_TYPE.API_KEY && (
                                <>
                                  {solutionApiKeyList.map((apiKey, index) => (
                                    <React.Fragment
                                      key={apiKey.uuid || `${index}-api-key`}
                                    >
                                      <Grid
                                        container
                                        spacing={1}
                                        margin={0}
                                        alignItems="center"
                                        sx={{
                                          mt: index === 0 ? 1 : 2,
                                          mb: 0.5,
                                        }}
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            ml: 1.5,
                                          }}
                                        >
                                          <Checkbox
                                            id={`isKeyValue_${index}`}
                                            name={`isKeyValue_${index}`}
                                            checked={!!apiKey.hasKeyValue}
                                            disabled
                                            sx={{ p: 0.5, mr: 1 }}
                                          />
                                          <Typography sx={{ fontWeight: 100 }}>
                                            Key Value
                                          </Typography>
                                        </Grid>
                                      </Grid>

                                      <Grid
                                        container
                                        spacing={1}
                                        margin={0}
                                        alignItems="center"
                                        sx={{ mb: 1, px: 2 }}
                                      >
                                        <Grid item xs={2.8}>
                                          <span>Key Name</span>
                                          <MandatoryField />
                                          <input
                                            id={`keyName_${index}`}
                                            name={`keyName_${index}`}
                                            className="form-label form-control"
                                            type="text"
                                            placeholder="Enter Key Name"
                                            style={{ width: "100%" }}
                                            value={apiKey.keyName}
                                            disabled
                                          />
                                        </Grid>
                                        <Grid item xs={2.6}>
                                          <span>User Label</span>
                                          <input
                                            id={`userLabel_${index}`}
                                            name={`userLabel_${index}`}
                                            className="form-label form-control"
                                            type="text"
                                            placeholder="User Label"
                                            style={{ width: "100%" }}
                                            value={apiKey.userLabel || ""}
                                            disabled
                                          />
                                        </Grid>
                                        <Grid item xs={2.6}>
                                          <span>Key Value</span>
                                          <MandatoryField />
                                          <input
                                            id={`keyValue_${index}`}
                                            name={`keyValue_${index}`}
                                            className="form-label form-control"
                                            type="text"
                                            placeholder="Enter Key Value"
                                            style={{ width: "100%" }}
                                            value={apiKey.keyValue}
                                            disabled
                                          />
                                        </Grid>
                                        <Grid item xs={2.5}>
                                          <span>Add to</span>
                                          <MandatoryField />
                                          <select
                                            id={`addTo_${index}`}
                                            name={`addTo_${index}`}
                                            className="form-label form-control"
                                            style={{ width: "100%" }}
                                            disabled
                                            value={apiKey.addTo}
                                            onChange={() => {}}
                                          >
                                            <option disabled value={0}>
                                              Select Add To
                                            </option>
                                            {addToOptions.map((option) => (
                                              <option
                                                key={option.key}
                                                value={option.key}
                                              >
                                                {option.value}
                                              </option>
                                            ))}
                                          </select>
                                        </Grid>
                                      </Grid>
                                    </React.Fragment>
                                  ))}
                                </>
                              )}
                            {solutionType === SOLUTION_TYPE.INCHANTED && (
                              <Grid item xs={12}>
                                <RadioGroup
                                  name="inchantedAddinType"
                                  value={inchantedAddinType || 0}
                                  onChange={() => {}}
                                >
                                  {inchantedAddinOptions.map((option) => (
                                    <FormControlLabel
                                      key={option.key}
                                      value={option.key}
                                      disabled
                                      control={<Radio size="small" />}
                                      label={option.value}
                                      sx={{
                                        margin: 0,
                                        alignItems: "center",
                                        "& .MuiFormControlLabel-label": {
                                          whiteSpace: "nowrap",
                                        },
                                      }}
                                    />
                                  ))}
                                </RadioGroup>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            marginTop: "16px",
                            marginLeft: "-20px",
                          }}
                        ></div>
                      </AccordionDetails>
                    </Accordion>
                  )}
                  {props.selectedSubTab === TABS.VENDOR_SERVICES && (
                    <Accordion
                      className="accordion-ent"
                      expanded={props.hideSolutionBasicDetails ? true : expanded2 === "panel2"}
                      onChange={handleChange2("panel2")}
                      disableGutters={!!props.hideSolutionBasicDetails}
                      square={!!props.hideSolutionBasicDetails}
                      sx={props.hideSolutionBasicDetails ? { boxShadow: "none", background: "transparent", "&:before": { display: "none" } } : undefined}
                    >
                      {!props.hideSolutionBasicDetails && (
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel2a-content"
                          id="panel2a-header"
                        >
                          <Typography sx={{ fontWeight: 700 }}>
                            Service Details
                          </Typography>
                        </AccordionSummary>
                      )}
                      <AccordionDetails
                        style={{
                          maxHeight: "100vh",
                          overflowX: "auto",
                          overflowY: "none",
                          marginBottom: "50px",
                        }}
                      >
                        <Tabs
                          value={selectedTab}
                          onChange={(e, newValue) => setSelectedTab(newValue)}
                          aria-label="Distributor Tabs"
                          className="content-tabs"
                        >
                          <Tab
                            label="Service Details"
                            value={TABS.SERVICE_BASIC}
                            className="content-sub-tabs"
                            {...a11yProps("Services", "Services")}
                          />
                          <Tab
                            label="Service Request"
                            value={TABS.SERVICE_REQUEST}
                            className="content-sub-tabs"
                            {...a11yProps("Services", "Services")}
                            disabled={formik.values?.integrationServiceId === 0}
                          />
                          <Tab
                            label="Service Response"
                            value={TABS.SERVICE_RESPONSE}
                            className="content-sub-tabs"
                            {...a11yProps("Services", "Services")}
                            disabled={formik.values?.integrationServiceId === 0}
                          />
                        </Tabs>
                        {selectedTab === TABS.SERVICE_BASIC && (
                          <div
                            className="blue-field-section"
                            style={{ margin: "10px" }}
                          >
                            <Grid container xs={12} margin={0}>
                              <Grid item xs={3} margin={2}>
                                <label htmlFor="serviceName">
                                  Service Name
                                  <MandatoryField />
                                </label>
                                <input
                                  id="serviceName"
                                  name="serviceName"
                                  className="form-label form-control"
                                  type="text"
                                  placeholder="Enter Service Name"
                                  style={{ width: "100%" }}
                                  disabled={!isEditMode}
                                  value={formik.values?.serviceName}
                                  onChange={(e) => {
                                    formik.setFieldValue("dirty", true);
                                    formik.handleChange(e);
                                  }}
                                />
                              </Grid>
                              <Grid item xs={3} margin={2}>
                                <label htmlFor="serviceAPIURL">
                                  Service API URL
                                  <MandatoryField />
                                </label>
                                <input
                                  id="serviceAPIURL"
                                  name="serviceAPIURL"
                                  className="form-label form-control"
                                  type="text"
                                  placeholder="Enter Service API URL"
                                  style={{ width: "100%" }}
                                  disabled={!isEditMode}
                                  value={formik.values?.serviceAPIURL}
                                  onChange={(e) => {
                                    formik.setFieldValue("dirty", true);
                                    formik.handleChange(e);
                                  }}
                                />
                              </Grid>
                              <Grid item xs={3} margin={2}>
                                <label htmlFor="integrationMethod">
                                  Integration Method
                                  <MandatoryField />
                                </label>
                                <select
                                  id="integrationMethod"
                                  name="integrationMethod"
                                  className="form-label form-control"
                                  style={{ width: "100%" }}
                                  disabled={!isEditMode}
                                  value={formik.values?.integrationMethod}
                                  onChange={(e) => {
                                    formik.setFieldValue("dirty", true);
                                    formik.setFieldValue(
                                      "integrationMethod",
                                      Number(e.target.value),
                                    );
                                  }}
                                >
                                  <option
                                    selected="true"
                                    disabled="true"
                                    value={0}
                                  >
                                    Select Integration Method
                                  </option>

                                  {[
                                    { label: "AL3", value: "1" },
                                    { label: "JSON", value: "2" },
                                    { label: "XML", value: "3" },
                                  ].map((method) => (
                                    <option
                                      key={method.value}
                                      value={method.value}
                                    >
                                      {method.label}
                                    </option>
                                  ))}
                                </select>
                              </Grid>
                            </Grid>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginTop: "16px",
                                marginLeft: "-20px",
                              }}
                            >
                              <FooterButtons
                                isEditMode={isEditMode}
                                permissions={vendorIntSolutionPermission}
                                permissionId={permissionId}
                                editPermission={
                                  integrationServiceId > 0 &&
                                  vendorIntSolutionPermission.includes(
                                    PermissionEnum.UPDATE,
                                  )
                                }
                                showUpdateNext={integrationServiceId > 0}
                                showSaveNext={integrationServiceId <= 0}
                                disableUpdateNext={
                                  !isEditMode || !formik.isValid
                                }
                                disableSaveNext={!isEditMode || !formik.isValid}
                                showUpdateDetail={integrationServiceId > 0}
                                disableUpdateDetail={
                                  !isEditMode || !formik.isValid
                                }
                                disableSaveDetail={
                                  !isEditMode || !formik.isValid
                                }
                                onCancel={onCancelHandler}
                                onEdit={onEditHandler}
                                onUpdateNext={() =>
                                  updateVendorSolutionServiceDetails(true)
                                }
                                onSaveNext={() => {
                                  addVendorSolutionServiceDetails(true);
                                }}
                                onUpdate={() =>
                                  updateVendorSolutionServiceDetails(false)
                                }
                                onSave={() => {
                                  addVendorSolutionServiceDetails(false);
                                }}
                                buttonType="button"
                              />
                            </div>
                          </div>
                        )}
                        {selectedTab === TABS.SERVICE_REQUEST && (
                          <div
                            className="blue-field-section"
                            style={{ margin: "10px" }}
                          >
                            <Grid container xs={12} margin={0}>
                              <Grid item xs={3} margin={1}>
                                <label htmlFor="httpVerb">
                                  HTTP Verb
                                  <MandatoryField />
                                </label>
                                <select
                                  id="httpVerb"
                                  name="httpVerb"
                                  className="form-label form-control"
                                  style={{ width: "100%" }}
                                  disabled={!isEditMode}
                                  value={
                                    formik.values?.integrationServiceRequest
                                      ?.httpVerb
                                  }
                                  onChange={(e) => {
                                    const selectedhttpVerbType = Number(
                                      e.target.value,
                                    );
                                    formik.setFieldValue("dirty", true);
                                    setFile(null);
                                    if (selectedhttpVerbType === 1) {
                                      formik.setValues({
                                        ...formik.values,
                                        integrationServiceRequest: {
                                          httpVerb: selectedhttpVerbType,
                                          requestGcpPath: null,
                                          requestParameterList: [
                                            {
                                              uniqueId: Math.floor(
                                                Math.random() * 1000,
                                              ),
                                              parameterName: null,
                                              source: null,
                                              eLabel: 0,
                                              clientDetails: 0,
                                              defaultValue: "",
                                            },
                                          ],
                                        },
                                      });
                                    } else {
                                      formik.setValues({
                                        ...formik.values,
                                        integrationServiceRequest: {
                                          httpVerb: selectedhttpVerbType,
                                          requestGcpPath: null,
                                          requestParameterList: [],
                                        },
                                      });
                                    }
                                  }}
                                >
                                  <option
                                    selected="true"
                                    disabled="true"
                                    value={0}
                                  >
                                    Select HTTP Verb
                                  </option>
                                  {[
                                    { label: "Get", value: 1 },
                                    { label: "Put", value: 2 },
                                    { label: "Post", value: 3 },
                                    { label: "Delete", value: 4 },
                                  ].map((method) => (
                                    <option
                                      key={method.value}
                                      value={method.value}
                                    >
                                      {method.label}
                                    </option>
                                  ))}
                                </select>
                              </Grid>
                              <Grid item xs={3} margin={2}></Grid>
                              <Grid item xs={3} margin={2}></Grid>
                              {formik.values?.integrationServiceRequest
                                ?.httpVerb === HTTPVERB.GET && (
                                <>
                                  {formik.values.integrationServiceRequest.requestParameterList?.map(
                                    (row, index) => (
                                      <Grid
                                        container
                                        xs={12}
                                        key={row.id}
                                        spacing={0}
                                        alignItems="center"
                                      >
                                        <Grid item xs={2.6} margin={0.5}>
                                          <label htmlFor="brandName">
                                            Parameter Name
                                            <MandatoryField />
                                          </label>
                                          <input
                                            id="brandName"
                                            name="brandName"
                                            className="form-label form-control"
                                            type="text"
                                            placeholder="Enter Parameter Name"
                                            style={{ width: "100%" }}
                                            value={row.parameterName}
                                            disabled={!isEditMode}
                                            onChange={(e) =>
                                              handleInputChange(
                                                row.uniqueId,
                                                "parameterName",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={4} margin={0.5}>
                                          <label htmlFor="source">
                                            Source
                                            <MandatoryField />
                                          </label>
                                          <select
                                            id="source"
                                            name="source"
                                            className="form-label form-control"
                                            style={{ width: "100%" }}
                                            disabled={!isEditMode}
                                            value={row.source}
                                            onChange={(e) =>
                                              handleInputChange(
                                                row.uniqueId,
                                                "source",
                                                Number(e.target.value),
                                              )
                                            }
                                          >
                                            <option
                                              selected="true"
                                              disabled="true"
                                              value={0}
                                            >
                                              Select
                                            </option>
                                            {sourceDropdown?.map((option) => (
                                              <option
                                                key={option.key}
                                                value={option.key}
                                              >
                                                {option.value}
                                              </option>
                                            ))}
                                          </select>
                                        </Grid>
                                        {row.source === 2 ? (
                                          <Grid item xs={3.5} margin={0.5}>
                                            <label htmlFor="clientDetails">
                                              Client Folder Details
                                              <MandatoryField />
                                            </label>
                                            <select
                                              id="clientDetails"
                                              name="clientDetails"
                                              className="form-label form-control"
                                              style={{ width: "100%" }}
                                              disabled={!isEditMode}
                                              value={row.clientDetails}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  row.uniqueId,
                                                  "clientDetails",
                                                  Number(e.target.value),
                                                )
                                              }
                                            >
                                              <option
                                                selected="true"
                                                disabled="true"
                                                value={0}
                                              >
                                                Select
                                              </option>
                                              {clientFolderDropdown?.map(
                                                (option) => (
                                                  <option
                                                    key={option.key}
                                                    value={option.key}
                                                  >
                                                    {option.value}
                                                  </option>
                                                ),
                                              )}
                                            </select>
                                          </Grid>
                                        ) : (
                                          <Grid item xs={3.5} margin={0.5}>
                                            <label htmlFor="eLabel">
                                              XFDL eLabel
                                              <MandatoryField />
                                            </label>
                                            <XFDLDropdown
                                              id="eLabel"
                                              placeholder="Select"
                                              width="100%"
                                              clearIcon="No"
                                              isEditMode={isEditMode}
                                              placement="top-start"
                                              disabled={
                                                !isEditMode || !row.source
                                              }
                                              dense
                                              dropdownWidth={500}
                                              options={eLabelDropdown.map(
                                                (opt) => ({
                                                  value: opt.key,
                                                  label: opt.value,
                                                }),
                                              )}
                                              value={
                                                row.eLabel
                                                  ? [
                                                      {
                                                        value: row.eLabel,
                                                        label:
                                                          eLabelDropdown.find(
                                                            (o) =>
                                                              o.key ===
                                                              row.eLabel,
                                                          )?.value,
                                                      },
                                                    ]
                                                  : []
                                              }
                                              setData={(selected) => {
                                                handleInputChange(
                                                  row.uniqueId,
                                                  "eLabel",
                                                  selected?.value || 0,
                                                );
                                              }}
                                            />
                                          </Grid>
                                        )}
                                        {index ===
                                          formik.values
                                            .integrationServiceRequest
                                            .requestParameterList.length -
                                            1 &&
                                          isEditMode && (
                                            <Grid item xs={0.3} mt={4} ml={1}>
                                              <AddOutlinedIcon
                                                name="add-icon"
                                                sx={{
                                                  cursor: "pointer",
                                                  color: "#1aaefa",
                                                }}
                                                onClick={handleAddRow}
                                              />
                                            </Grid>
                                          )}
                                        {isEditMode && (
                                          <Grid item xs={0.3} mt={4} ml={2}>
                                            <DeleteOutlineIcon
                                              sx={{
                                                cursor: "pointer",
                                                color: "red",
                                              }}
                                              onClick={() => {
                                                handleRemoveRow(row.uniqueId);
                                              }}
                                            />
                                          </Grid>
                                        )}
                                      </Grid>
                                    ),
                                  )}
                                </>
                              )}
                              {(formik.values?.integrationServiceRequest
                                ?.httpVerb === HTTPVERB.POST ||
                                formik.values?.integrationServiceRequest
                                  ?.httpVerb === HTTPVERB.PUT ||
                                formik.values?.integrationServiceRequest
                                  ?.httpVerb === HTTPVERB.DELETE) && (
                                <>
                                  <Grid item xs={5} margin={1.3}>
                                    <label
                                      htmlFor="application"
                                      className="file-upload-label"
                                    >
                                      <span>
                                        Upload File <MandatoryField />
                                      </span>
                                    </label>
                                    <FileUploader
                                      accept=".xml,.json"
                                      onSelectFile={handleFileChange}
                                      onDeleteFile={onDeleteFileHandler}
                                      sourceFile={file}
                                      disabled={!isEditMode}
                                      deleteDisable={
                                        !formik.values
                                          ?.integrationServiceRequest
                                          ?.requestGcpPath
                                      }
                                    />
                                    {formik.values?.integrationServiceRequest
                                      ?.requestGcpPath !== "" && (
                                      <div>
                                        {
                                          formik.values
                                            ?.integrationServiceRequest
                                            ?.requestGcpPath
                                        }
                                      </div>
                                    )}
                                  </Grid>
                                  <Grid item xs={4} mt={4.5} ml={2}>
                                    <Button
                                      variant="contained"
                                      className="action-button"
                                      onClick={() => handlePrepareSchema()}
                                      disabled={!isEditMode || !file}
                                    >
                                      Prepare Schema
                                    </Button>
                                  </Grid>
                                </>
                              )}
                            </Grid>
                            {(formik.values?.integrationServiceRequest
                              ?.httpVerb === HTTPVERB.POST ||
                              formik.values?.integrationServiceRequest
                                ?.httpVerb === HTTPVERB.PUT ||
                              formik.values?.integrationServiceRequest
                                ?.httpVerb === HTTPVERB.DELETE) && (
                              <>
                                <Tabs
                                  value={selectedTab}
                                  onChange={(e, newValue) =>
                                    setSelectedTab(newValue)
                                  }
                                  aria-label="Distributor Tabs"
                                  className="service-tabs"
                                  sx={{ background: "#f4f4f4" }}
                                >
                                  <Grid item xs={6} ml={2} mt={0.5}>
                                    <span
                                      style={{
                                        color: "black",
                                        fontWeight: "500",
                                      }}
                                    >
                                      API Schema
                                    </span>
                                  </Grid>

                                  <Grid item xs={6} ml={2} mt={0.5}>
                                    <span
                                      style={{
                                        color: "black",
                                        fontWeight: "500",
                                      }}
                                    >
                                      Enchanted eLabels
                                    </span>
                                  </Grid>
                                </Tabs>
                                <Grid
                                  container
                                  xs={12}
                                  spacing={0}
                                  margin={1}
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    overflow: "auto",
                                  }}
                                  className="blue-field-section"
                                >
                                  <Grid item xs={12} marginLeft={-1} mt={0.7}>
                                    <div>
                                      {formik.values.integrationServiceRequest
                                        ?.requestParameterList ? (
                                        <APISchemaTree
                                          keyValueList={
                                            formik.values
                                              .integrationServiceRequest
                                              ?.requestParameterList
                                          }
                                          handleSchemaValue={
                                            handleSchemaRequestValue
                                          }
                                          isEditMode={isEditMode}
                                          formik={formik}
                                          sourceDropdown={sourceDropdown}
                                          clientFolderDropdown={
                                            clientFolderDropdown
                                          }
                                          eLabelDropdown={eLabelDropdown}
                                        />
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </Grid>
                                </Grid>
                              </>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginTop: "16px",
                                marginLeft: "-20px",
                              }}
                            >
                              <FooterButtons
                                isEditMode={isEditMode}
                                permissions={vendorIntSolutionPermission}
                                permissionId={permissionId}
                                editPermission={
                                  integrationServiceId > 0 &&
                                  vendorIntSolutionPermission.includes(
                                    PermissionEnum.UPDATE,
                                  )
                                }
                                showUpdateNext={integrationServiceId > 0}
                                showSaveNext={integrationServiceId <= 0}
                                disableUpdateNext={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaError ||
                                  Number(
                                    formik.values?.integrationServiceRequest
                                      ?.httpVerb,
                                  ) <= 0
                                }
                                disableSaveNext={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaError ||
                                  Number(
                                    formik.values?.integrationServiceRequest
                                      ?.httpVerb,
                                  ) <= 0
                                }
                                showUpdateDetail={integrationServiceId > 0}
                                disableUpdateDetail={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaError ||
                                  Number(
                                    formik.values?.integrationServiceRequest
                                      ?.httpVerb,
                                  ) <= 0
                                }
                                disableSaveDetail={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaError ||
                                  Number(
                                    formik.values?.integrationServiceRequest
                                      ?.httpVerb,
                                  ) <= 0
                                }
                                onCancel={onCancelHandler}
                                onEdit={onEditHandler}
                                onUpdateNext={() =>
                                  updateVendorSolutionServiceDetails(true)
                                }
                                onSaveNext={() => {
                                  updateVendorSolutionServiceDetails(true);
                                }}
                                onUpdate={() =>
                                  updateVendorSolutionServiceDetails(false)
                                }
                                onSave={() => {
                                  updateVendorSolutionServiceDetails(false);
                                }}
                                buttonType="button"
                              />
                            </div>
                          </div>
                        )}
                        {selectedTab === TABS.SERVICE_RESPONSE && (
                          <div
                            className="blue-field-section"
                            style={{ margin: "10px" }}
                          >
                            <Grid container xs={12} margin={0}>
                              <Grid item xs={5} p={2}>
                                <label
                                  htmlFor="application"
                                  className="file-upload-label"
                                >
                                  <span>
                                    Upload File <MandatoryField />
                                  </span>
                                </label>
                                <FileUploader
                                  accept=".xml,.json"
                                  onSelectFile={handleFileChangeResponse}
                                  onDeleteFile={onDeleteFileHandlerResponse}
                                  sourceFile={fileResponse}
                                  disabled={!isEditMode}
                                  deleteDisable={
                                    !formik.values?.integrationServiceResponse
                                      ?.responseGcpPath
                                  }
                                />
                                {formik.values?.integrationServiceResponse
                                  ?.responseGcpPath !== "" && (
                                  <div>
                                    {
                                      formik.values?.integrationServiceResponse
                                        ?.responseGcpPath
                                    }
                                  </div>
                                )}
                              </Grid>
                              <Grid item xs={4} mt={5} ml={2}>
                                <Button
                                  variant="contained"
                                  className="action-button"
                                  onClick={() => handlePrepareSchemaResponse()}
                                  disabled={!isEditMode || !fileResponse}
                                >
                                  Prepare Schema
                                </Button>
                              </Grid>
                            </Grid>
                            <Tabs
                              value={selectedTab}
                              onChange={(e, newValue) =>
                                setSelectedTab(newValue)
                              }
                              aria-label="Distributor Tabs"
                              className="service-tabs"
                              sx={{ background: "#f4f4f4" }}
                            >
                              <Grid item xs={6} ml={2} mt={0.5}>
                                <span
                                  style={{
                                    color: "black",
                                    fontWeight: "500",
                                  }}
                                >
                                  API Schema
                                </span>
                              </Grid>
                              <Grid item xs={6} ml={2} mt={0.5}>
                                <span
                                  style={{
                                    color: "black",
                                    fontWeight: "500",
                                  }}
                                >
                                  Inchanted eLabels
                                </span>
                              </Grid>
                            </Tabs>
                            <Grid
                              container
                              xs={12}
                              spacing={0}
                              margin={1}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                overflow: "auto",
                              }}
                              className="blue-field-section"
                            >
                              <Grid item xs={12} marginLeft={-1} mt={0.7}>
                                <div>
                                  {formik.values.integrationServiceResponse
                                    ?.responseParameterList ? (
                                    <APISchemaTree
                                      keyValueList={
                                        formik.values.integrationServiceResponse
                                          ?.responseParameterList
                                      }
                                      handleSchemaValue={
                                        handleSchemaResponseValue
                                      }
                                      isEditMode={isEditMode}
                                      formik={formik}
                                      sourceDropdown={sourceDropdown}
                                      clientFolderDropdown={
                                        clientFolderDropdown
                                      }
                                      eLabelDropdown={eLabelDropdown}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                                marginTop: "16px",
                                marginLeft: "-20px",
                              }}
                            >
                              <FooterButtons
                                isEditMode={isEditMode}
                                permissions={vendorIntSolutionPermission}
                                permissionId={permissionId}
                                editPermission={
                                  integrationServiceId > 0 &&
                                  vendorIntSolutionPermission.includes(
                                    PermissionEnum.UPDATE,
                                  )
                                }
                                showUpdateNext={false}
                                showSaveNext={false}
                                showAddNew={integrationServiceId > 0}
                                showupdateAddNew={integrationServiceId === 0}
                                disableSaveAddNew={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                disableUpdateAddNew={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                disableUpdateNext={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                disableSaveNext={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                showUpdateDetail={integrationServiceId > 0}
                                disableUpdateDetail={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                disableSaveDetail={
                                  !isEditMode ||
                                  !formik.isValid ||
                                  schemaErrorResp
                                }
                                onCancel={onCancelHandler}
                                onEdit={onEditHandler}
                                onSaveAddNew={() =>
                                  updateVendorSolutionServiceDetails(true)
                                }
                                onUpdate={() =>
                                  updateVendorSolutionServiceDetails(false)
                                }
                                onSave={() => {
                                  updateVendorSolutionServiceDetails(false);
                                }}
                                buttonType="button"
                              />
                            </div>
                          </div>
                        )}
                      </AccordionDetails>
                    </Accordion>
                  )}
                </div>
              </form>
            </Box>
          )}
        </Box>
      </Grid>

      {!openServiceModal && (
      <Grid item xs={12}>
        <Box
          sx={{
            background: "#fff",
            borderRadius: "12px",
            border: "1px solid #e3e6ed",
            boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
            padding: "16px 20px",
            marginTop: "12px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <Typography
              sx={{ fontWeight: 700, fontSize: "16px", color: "#1f2a44" }}
            >
              Services
            </Typography>
          </Box>
          <DataTable
            uniqueKey="integrationServiceId"
            query={query}
            columns={selectedColumns}
            adminTable={vendorTable}
            onSearch={onSearchHandler}
            onSort={sortHandler}
            onPageSizeChange={pageSizeChangeHandler}
            handleChangePage={handleChangePageNumber}
            totalPages={totalPages}
            pageSize={pageSize}
            onCheckboxChange={onCheckboxChangeHandler}
            permissions={vendorIntSolutionPermission}
            onToggle={onToggleHandler}
            onEdit={(data) => onEdit(data)}
            onView={(data) => onView(data)}
            checkboxesNotRequired={true}
            showToggle={true}
            showEdit={true}
            showView={true}
          />
          <Confirmation
            open={confirmation}
            handleClose={handleConfirmationClose}
            title={confirmationMessage}
            cancelButtonLabel="No"
            confirmButtonLabel="Yes"
            onCancel={() => {
              handleConfirmationClose();
            }}
            onConfirm={() => {
              changeContentStatus(selectedSolution, STATUS_ENUM.INACTIVE);
            }}
          />
        </Box>
      </Grid>
      )}
    </>
  );
};

IntServiceList.propTypes = {
  vendorId: PropTypes.number.isRequired,
  integrationSolutionId: PropTypes.number.isRequired,
  shouldOpenServiceModal: PropTypes.bool,
  setShouldOpenServiceModal: PropTypes.func.isRequired,
  selectedSubTab: PropTypes.oneOf(Object.values(TABS)).isRequired,
  onCancel: PropTypes.func,
  hideSolutionBasicDetails: PropTypes.bool,
};

IntServiceList.defaultProps = {
  shouldOpenServiceModal: false,
  onCancel: undefined,
  hideSolutionBasicDetails: false,
};

export default IntServiceList;
/*istanbul ignore next */
function createKeyValueList(flattenedJson) {
  /*istanbul ignore next */
  return Object.keys(flattenedJson).map((key) => ({
    parameterName: key,
    source: 0,
    eLabel: 0,
    clientDetails: 0,
    defaultValue: null,
    value: flattenedJson[key],
  }));
}
